import { getWorkOrderResources } from "@/pages/work-orders/repositorie/WorkOrdersRepositorie";
import { get } from "lodash-es";

type Props = {
	WorkOrderId: number | null;
	setWorkOrderAttachmentsList: Function;
	setWorkOrderDrawingsList: Function;
	setWorkOrderLOTOList: Function;
	setWorkOrderPartsList: Function;
	setIsLoadingWorkOrderResourcesList: (isLoading: boolean) => void;
	setErrorWorkOrderResourcesList: (err: string) => void;
};

export const useSearchWorkOrderResources = ({
	WorkOrderId,
	setWorkOrderAttachmentsList,
	setWorkOrderDrawingsList,
	setWorkOrderLOTOList,
	setWorkOrderPartsList,
	setIsLoadingWorkOrderResourcesList,
	setErrorWorkOrderResourcesList,
}: Props) => {
	return async () => {
		setIsLoadingWorkOrderResourcesList(true);
		const res = await getWorkOrderResources(WorkOrderId as number);
		if (res.ok) {
			const WorkOrderDrawingsList = get(res, "data.tables[0].rows", []);
			setWorkOrderDrawingsList(WorkOrderDrawingsList);
			const WorkOrderLOTOList = get(res, "data.tables[1].rows", []);
			setWorkOrderLOTOList(WorkOrderLOTOList);
			const WorkOrderPartsList = get(res, "data.tables[2].rows", []);
			setWorkOrderPartsList(WorkOrderPartsList);
			const WorkOrderAttchmentsList = get(res, "data.tables[3].rows", []);
			setWorkOrderAttachmentsList(WorkOrderAttchmentsList);
			setIsLoadingWorkOrderResourcesList(false);
		} else {
			setIsLoadingWorkOrderResourcesList(false);
			setErrorWorkOrderResourcesList(res.message);
		}
	};
};
